import React, { useEffect, useState } from "react";
import { Progress} from "antd";

const LoadingBar = ({ loading = true }) => {
  const [percent, setPercent] = useState(0);

  useEffect(() => {
    let interval;

    if (loading) {
      setPercent(0);
      interval = setInterval(() => {
        setPercent((prev) => (prev >= 98 ? prev : prev + 1));
      }, 30);
    } else {
      setPercent(100);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [loading]);

  return (
    <div style={{ height: "calc(100vh - 200px)", width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "16px",
          width: "40%",
          flexDirection: "column",
          margin: "auto auto",
          border: "2px solid #28398A",
          borderRadius: "50px",
          paddingLeft: "6px",
        }}
      >
        <Progress style={{ marginTop: "5px" }} strokeLinecap="round" strokeColor="#28398A" percent={percent} showInfo={false} status="active" />
      </div>
    </div>
  );
};

export default LoadingBar;
